import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { innerBorder } from '@doltech/utils/lib/css-style';
import { colorsV2 } from '../../../colors-v2';
import { ResponsiveTypography } from '../../../Typography/v3/ResponsiveTypography';
import { InputContentAutoSize } from '../../../Input/InputContentAutoSize/InputContentAutoSize';

const LINE_SIZE = 1;

const InputText = styled.span`
  display: inline-block;

  input {
    font-size: 16px;
    line-height: 0;
    max-width: fit-content;
  }
`;

const Container = styled.span`
  display: inline;
  color: ${colorsV2.neutral180};

  .input-text {
    ${innerBorder(`${LINE_SIZE}px solid ${colorsV2.neutral40}`, 'bottom')}
  }

  &:hover:not(:focus):not(:focus-within):not(.readonly) {
    .input-text {
      background-color: ${colorsV2.neutral10};
      ${innerBorder(`${LINE_SIZE}px solid ${colorsV2.neutral80}`, 'bottom')}
    }
  }

  &.filled:not(.readonly) {
    color: ${colorsV2.blue100};
  }

  &:focus,
  &:focus-within {
    color: ${colorsV2.blue100};

    .input-text {
      ${innerBorder(`${LINE_SIZE}px solid ${colorsV2.blue100}`, 'bottom')}
    }
  }

  &.readonly {
    overflow-wrap: break-word;
    text-decoration-style: solid;
    text-decoration-line: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 7px;
  }

  &.correct {
    color: ${colorsV2.green100};
  }

  &.incorrect {
    color: ${colorsV2.red100};
  }
`;

interface ExerciseBlockFieldItemTextProps {
  className?: string;
  status?: 'default' | 'correct' | 'incorrect';
  defaultValue?: string;
  value?: string;
  onChange?: (changedValue: string) => void;
  onPaste?: (event: any) => void;
  readonly?: boolean;
}

export const ExerciseBlockFieldItemText = (props: ExerciseBlockFieldItemTextProps) => {
  const { className, status = 'default', defaultValue, value: inputValue, onChange, onPaste, readonly = false } = props;
  const [value, setValue] = React.useState(defaultValue || null);
  const filled = Boolean(value);

  if (readonly) {
    return (
      <Container className={cl('exercise-block-field-item-text', className, status, { readonly })}>
        <ResponsiveTypography.Text className="item-text" variant="medium/16-20">
          {inputValue}
        </ResponsiveTypography.Text>
      </Container>
    );
  }

  return (
    <Container className={cl('exercise-block-field-item-text', className, status, { filled })}>
      <InputText className="input-text">
        <InputContentAutoSize
          defaultValue={defaultValue}
          value={inputValue || ''}
          onChange={(changedValue) => {
            setValue(changedValue);
            onChange?.(changedValue);
          }}
          onPaste={onPaste}
        />
      </InputText>
    </Container>
  );
};
